/** Intranet division/unit or extranet submitted agency for cover note header. */
export function criminalCoverNoteDivisionUnit(
  submittedDivisionName: string | null | undefined = '',
  submittedAgency: string | null | undefined = '',
): string {
  const division = (submittedDivisionName ?? '').trim();
  if (division) return division;
  return (submittedAgency ?? '').trim();
}

/** Accused name with status, e.g. "Accused 1 (Not yet arrested)". */
export function criminalCoverNoteAccusedDisplay(name: string, status = ''): string {
  const n = name.trim();
  const s = status.trim();
  if (n && s) return `${n} (${s})`;
  return n || s;
}

export type CriminalCoverNoteSuspectLike = {
  suspectName?: string;
  suspectStatus?: string;
};

/** Cover note accused display — prefers API suspects array, falls back to legacy single fields. */
export function criminalCoverNoteSuspectsDisplay(
  suspects: CriminalCoverNoteSuspectLike[],
  fallbackName = '',
  fallbackStatus = '',
): string {
  const rows = suspects
    .map((s) => criminalCoverNoteAccusedDisplay(s.suspectName ?? '', s.suspectStatus ?? ''))
    .filter(Boolean);
  if (rows.length) return rows.join(', ');
  return criminalCoverNoteAccusedDisplay(fallbackName, fallbackStatus);
}
